import { setupContentUrl } from 'utils/contentUtils';

const splitTextIntoLines = (text, maxCharsPerLine = 26) => {
  if (!text) return [''];

  const words = text.split(' ');
  const lines = [];
  let currentLine = '';

  words.forEach((word) => {
    const testLine = currentLine ? `${currentLine} ${word}` : word;

    if (testLine.length <= maxCharsPerLine) {
      currentLine = testLine;
    } else {
      if (currentLine) lines.push(currentLine);
      currentLine = word;
    }
  });

  if (currentLine) lines.push(currentLine);

  return lines;
};

const useRoamingBanner = (roamingBannerData) => ({
  formattedTitle: splitTextIntoLines(roamingBannerData?.title || '', 26),
  description: roamingBannerData?.description || '',
  buttonText: roamingBannerData?.buttonText || '',
  redirectUrl: roamingBannerData?.url || '',
  imageSrc: roamingBannerData?.imageUrl ? setupContentUrl(roamingBannerData.imageUrl) : null,
});

export default useRoamingBanner;
